// extracted by mini-css-extract-plugin
export default {"containerText":"Headline_containerText__-e1KN"};